/* Lotus Edition Luxe behaviour */
(function () {
  document.body.classList.add('lx-root');
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  var group = document.getElementById('header-group'), bar = $('.lx-bar');
  function stick() { if (group) group.style.top = (bar ? -bar.offsetHeight : 0) + 'px'; }
  stick(); window.addEventListener('resize', stick);

  var btn = $('.lx-menu-btn'), drawer = $('#lx-drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function () {
      var open = drawer.hasAttribute('hidden');
      if (open) drawer.removeAttribute('hidden'); else drawer.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { drawer.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }); });
  }

  var rev = $$('.lx-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    rev.forEach(function (el) { io.observe(el); });
  } else { rev.forEach(function (el) { el.classList.add('is-visible'); }); }

  $$('.lx-rail').forEach(function (r) {
    var t = $('.lx-rail__track', r);
    $$('[data-rail]', r).forEach(function (b) {
      b.addEventListener('click', function () { t.scrollBy({ left: +b.getAttribute('data-rail') * t.clientWidth * 0.9, behavior: 'smooth' }); });
    });
  });

  var grid = $('#lx-grid'), current = 'all', page = 1;
  var per = grid ? (+grid.getAttribute('data-per-page') || 15) : 15;
  var pager = $('#lx-pager');
  var labels = { earrings: 'earrings', bangles: 'bangles', sets: 'necklace sets', tikka: 'maang tikka', sale: 'sale', under30: 'pieces under $30', under50: 'pieces under $50' };
  function drawPager(pages) {
    if (!pager) return;
    if (pages < 2) { pager.setAttribute('hidden', ''); pager.innerHTML = ''; return; }
    pager.removeAttribute('hidden');
    var h = '<button type="button" class="lx-pager__nav" data-page="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="Previous page">Previous</button><span class="lx-pager__nums">';
    for (var p = 1; p <= pages; p++) {
      h += '<button type="button" class="lx-pager__num' + (p === page ? ' is-on" aria-current="page"' : '"') + ' data-page="' + p + '" aria-label="Page ' + p + '">' + p + '</button>';
    }
    h += '</span><button type="button" class="lx-pager__nav" data-page="' + (page + 1) + '"' + (page === pages ? ' disabled' : '') + ' aria-label="Next page">Next</button>';
    pager.innerHTML = h;
  }
  function apply() {
    if (!grid) return;
    var cards = $$('.lx-card', grid), shown = 0;
    var sort = $('#lx-sort') ? $('#lx-sort').value : 'featured';
    var offerFirst = current === 'bangles' && sort === 'featured';
    var isOffer = function (c) { return c.querySelector('.lx-card__offer') ? 1 : 0; };
    cards.sort(function (a, b) {
      if (offerFirst && isOffer(a) !== isOffer(b)) return isOffer(b) - isOffer(a);
      if (sort === 'low') return +a.dataset.price - +b.dataset.price;
      if (sort === 'high') return +b.dataset.price - +a.dataset.price;
      return +a.dataset.index - +b.dataset.index;
    }).forEach(function (c) { grid.insertBefore(c, $('#lx-empty')); });
    var matched = cards.filter(function (c) {
      if (current === 'all') return true;
      var cap = { under30: 3000, under50: 5000 }[current];
      if (cap) return +c.getAttribute('data-price') <= cap;
      return (' ' + (c.getAttribute('data-cats') || '') + ' ').indexOf(' ' + current + ' ') > -1;
    });
    shown = matched.length;
    var pages = Math.max(1, Math.ceil(shown / per));
    if (page > pages) page = pages;
    var from = (page - 1) * per, to = from + per;
    cards.forEach(function (c) { c.classList.add('is-hidden'); });
    matched.forEach(function (c, k) { if (k >= from && k < to) c.classList.remove('is-hidden'); });
    drawPager(pages);
    var cl = $('#lx-count');
    if (cl) {
      var note = $('#lx-offer-note');
      if (!note) {
        note = document.createElement('p'); note.id = 'lx-offer-note'; note.className = 'lx-offer-note';
        note.innerHTML = '<strong>Festive offer, ends Nov 8:</strong> mix any 2 of these bangle sets and save 10%: <span class="lx-offer-note__names"></span>. They are shown first below with a green “Mix any 2 bangle sets, save 10%” label. The 10% comes off automatically at checkout.';
        cl.parentNode.insertBefore(note, cl);
      }
      var names = cards.filter(isOffer).map(function (c) { var t = c.querySelector('.lx-card__title'); return t ? t.textContent.trim() : ''; }).filter(Boolean);
      note.querySelector('.lx-offer-note__names').textContent = names.join(', ');
      note.hidden = current !== 'bangles' || !names.length;
    }
    var count = $('#lx-count');
    if (count) {
      var noun = shown === 1 ? ' piece' : ' pieces';
      count.textContent = pages > 1 ? 'Showing ' + (from + 1) + ' to ' + Math.min(to, shown) + ' of ' + shown + noun : shown + noun;
    }
    var empty = $('#lx-empty');
    if (empty) {
      if (shown) empty.setAttribute('hidden', '');
      else { empty.removeAttribute('hidden'); empty.textContent = 'New ' + (labels[current] || 'pieces') + ' are arriving soon. Follow us on Instagram to see them first.'; }
    }
  }
  function setFilter(f, scroll) {
    current = f; page = 1;
    $$('.lx-tab').forEach(function (t) { var on = t.getAttribute('data-filter') === f; t.classList.toggle('is-active', on); t.setAttribute('aria-checked', on ? 'true' : 'false'); });
    apply();
    var on = $('.lx-tab.is-active');
    if (on && on.parentNode && on.parentNode.scrollWidth > on.parentNode.clientWidth) {
      var row = on.parentNode, dx = on.getBoundingClientRect().left - row.getBoundingClientRect().left;
      row.scrollBy({ left: dx - (row.clientWidth - on.offsetWidth) / 2, behavior: 'smooth' });
    }
    if (scroll) { var s = $('#shop'); if (s) s.scrollIntoView({ behavior: 'smooth' }); }
  }
  $$('.lx-tab').forEach(function (t) { t.addEventListener('click', function () { setFilter(t.getAttribute('data-filter'), false); }); });
  $$('.lx-cat').forEach(function (c) { c.addEventListener('click', function () { setFilter(c.getAttribute('data-filter'), true); }); });
  $$('[data-filter-link]').forEach(function (a) { a.addEventListener('click', function (e) { if (grid) { e.preventDefault(); setFilter(a.getAttribute('data-filter-link'), true); } }); });
  var sel = $('#lx-sort'); if (sel) sel.addEventListener('change', function () { page = 1; apply(); });
  if (pager) pager.addEventListener('click', function (e) {
    var b = e.target.closest('[data-page]'); if (!b || b.disabled) return;
    page = +b.getAttribute('data-page'); apply();
    var s = $('#lx-shop-title') || $('#shop'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  apply();
})();

/* Announcement rotation, add to bag without leaving the page, final sale notes */
(function () {
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var FREE_SHIP = 7500;

  /* Messages rotate; a message too long for the screen slides left to show the rest.
     Shoppers can also drag a long message with a finger, or swipe to the next one. */
  var msgs = $$('.lx-bar__msg'), bar = $('.lx-bar');
  if (msgs.length && bar) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mi = Math.max(0, msgs.findIndex(function (m) { return m.classList.contains('is-on'); }));
    var btimer, raf, held = false, resume, lastLong = null;
    var stopAll = function () { clearTimeout(btimer); cancelAnimationFrame(raf); };
    var overOf = function (m) { return m.scrollWidth - m.clientWidth; };
    var show = function (n) {
      msgs[mi].classList.remove('is-on');
      mi = (n + msgs.length) % msgs.length;
      msgs[mi].scrollLeft = 0;
      msgs[mi].classList.add('is-on');
      run();
    };
    var run = function () {
      stopAll();
      var m = msgs[mi], over = overOf(m);
      lastLong = over > 4;
      m.classList.toggle('is-long', lastLong);
      if (held) return;
      if (over > 4 && !reduce) {
        btimer = setTimeout(function () {
          var last = null, pos = m.scrollLeft;
          var step = function (ts) {
            if (last === null) last = ts;
            pos = Math.min(overOf(m), pos + (ts - last) * 0.09); last = ts;
            m.scrollLeft = Math.round(pos);
            if (pos < overOf(m) - 1) raf = requestAnimationFrame(step);
            else btimer = setTimeout(function () { show(mi + 1); }, 1800);
          };
          raf = requestAnimationFrame(step);
        }, 1400);
      } else if (msgs.length > 1) {
        btimer = setTimeout(function () { show(mi + 1); }, over > 4 ? 8000 : 3800);
      }
    };
    var x0 = null;
    var hold = function (e) { held = true; stopAll(); clearTimeout(resume); x0 = e.touches ? e.touches[0].clientX : e.clientX; };
    var release = function (e) {
      var x1 = e.changedTouches ? e.changedTouches[0].clientX : e.clientX, dx = x0 === null ? 0 : x1 - x0;
      x0 = null;
      if (Math.abs(dx) > 40 && overOf(msgs[mi]) <= 4 && msgs.length > 1) { held = false; show(mi + (dx < 0 ? 1 : -1)); return; }
      clearTimeout(resume);
      resume = setTimeout(function () { held = false; run(); }, 4000);
    };
    bar.addEventListener('touchstart', hold, { passive: true });
    bar.addEventListener('touchend', release);
    bar.addEventListener('mousedown', hold);
    bar.addEventListener('mouseup', release);
    var check = function () { if (!held && (overOf(msgs[mi]) > 4) !== lastLong) run(); };
    if (window.ResizeObserver) new ResizeObserver(check).observe(msgs[0].parentNode);
    else window.addEventListener('resize', check);
    msgs.forEach(function (m) {
      m.addEventListener('wheel', function () { held = true; stopAll(); clearTimeout(resume); resume = setTimeout(function () { held = false; run(); }, 4000); }, { passive: true });
    });
    run();
    window.addEventListener('load', check);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function setCount(n) {
    $$('.lx-header a.lx-icon[href*="/cart"]').forEach(function (a) {
      var b = $('.lx-count', a);
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'lx-count'; a.appendChild(b); }
        b.textContent = n;
      } else if (b) { b.remove(); }
      a.setAttribute('aria-label', 'Shopping bag, ' + n + ' items');
    });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; });
  }

  var toast, timer;
  function closeToast() { if (toast) toast.classList.remove('is-open'); clearTimeout(timer); }
  function openToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lx-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) { if (e.target.closest('[data-lx-close]')) closeToast(); });
      toast.addEventListener('mouseenter', function () { clearTimeout(timer); });
      toast.addEventListener('mouseleave', function () { timer = setTimeout(closeToast, 3500); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeToast(); });
    }
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    clearTimeout(timer);
    timer = setTimeout(closeToast, 6500);
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  function added(item, cart) {
    var left = FREE_SHIP - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100));
    var ship = left > 0 ? 'Add <strong>' + money(left) + '</strong> more for free shipping' : 'Your order ships <strong>free</strong>';
    var img = item && (item.image || (item.featured_image && item.featured_image.url));
    openToast(
      '<div class="lx-toast__row">' +
        (img ? '<img src="' + esc(img) + '" alt="">' : '') +
        '<div><p class="lx-toast__kicker">Added to your bag</p><p class="lx-toast__title">' + esc(item && (item.product_title || item.title)) + '</p></div>' +
        '<button type="button" class="lx-toast__x" data-lx-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<p class="lx-toast__ship">' + ship + '</p>' +
      '<div class="lx-toast__bar"><span style="width:' + pct + '%"></span></div>' +
      '<div class="lx-toast__actions">' +
        '<button type="button" class="lx-toast__btn" data-lx-close>Keep Shopping</button>' +
        '<a class="lx-toast__btn lx-toast__btn--solid" href="/cart">View Bag (' + cart.item_count + ')</a>' +
      '</div>'
    );
  }
  function failed(msg) {
    openToast('<div class="lx-toast__row"><div><p class="lx-toast__kicker">Could not add</p><p class="lx-toast__title">' + esc(msg || 'Please try again.') + '</p></div><button type="button" class="lx-toast__x" data-lx-close aria-label="Close">&times;</button></div>');
  }

  if (window.fetch && !window.__lxFetch) {
    window.__lxFetch = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) {
          if (!/\/cart\/add/.test(url)) { setTimeout(getCart, 250); return; }
          r.clone().json().then(function (d) {
            if (!r.ok || d.status) { getCart(); failed(d.description || d.message); return; }
            var item = d.items && d.items.length ? d.items[0] : d;
            getCart().then(function (c) { added(item, c); });
          }).catch(function () { getCart(); });
        }).catch(function () {});
      }
      return p;
    };
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (f.classList.contains('shopify-product-form') || f.closest('product-form-component')) return;
    e.preventDefault();
    var b = $('[type="submit"]', f), label = b ? b.textContent : '';
    if (b) { b.disabled = true; b.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .catch(function () { failed(); })
      .then(function () {
        if (b) { b.textContent = 'Added'; setTimeout(function () { b.disabled = false; b.textContent = label; }, 1400); }
      });
  });

  var NOTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12.5l-7.5 7.5L4 11.5V4h7.5z"/><circle cx="8" cy="8" r="1.4"/></svg><span><strong>All sales are final.</strong> Orders can\'t be cancelled once placed.</span>';
  function note() { var p = document.createElement('p'); p.className = 'lx-final'; p.innerHTML = NOTE; return p; }
  function placeNotes() {
    $$('form.shopify-product-form[action*="/cart/add"]').forEach(function (f) {
      if (f.closest('[class*="quick-add"], product-card, .product-card, dialog')) return;
      var n = f.nextElementSibling;
      if (!(n && n.classList.contains('lx-final'))) f.parentNode.insertBefore(note(), f.nextSibling);
    });
    $$('button[name="checkout"], #checkout').forEach(function (c) {
      var host = c.parentNode;
      if (host && !$('.lx-final', host.parentNode || host)) host.parentNode.insertBefore(note(), host);
    });
  }
  placeNotes();
  var pending;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(placeNotes, 150); })
    .observe(document.body, { childList: true, subtree: true });
})();